import * as React from 'react';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { ListBlackListComponentProps, ListBlackListComponentState, ListBlackListComponentHandler } from './listblacklistcomponent';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ListBlackListCSSStyle } from './listblacklistcss';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonCSSStyleImpl } from '../../../../toolkit/button/buttoncss';
import {  BlackListViewModelImpl } from './viewmodel/blacklistviewmodel';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { VerticalListComponent } from '../../../../toolkit/verticallist/verticallistcomponent';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';

export class ListBlackListViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private popupComponent: PopUpWrapperComponent;
    // private cssStyle:ListBlackListCSSStyleImpl;
    private listViewModel : BlackListViewModelImpl;
    private loaderWrapperComponent:LoaderWrapperComponent;

    bindHandlers()
    {
        this.onADDNumberClicked = this.onADDNumberClicked.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        //
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        }
    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
  {
      super(applicationContext, uiComponentHandler);
      console.log("Inside blacklist view");
      this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
      this.listViewModel = new BlackListViewModelImpl(0,applicationContext, this.onDeleteButtonClick);
    //   this.cssStyle =  this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? 
    //   new ListBlackListCSSStyleImpl(this.getContext()) : new ArabicListBlackListCSSStyleImpl(this.getContext());

  }
   
    draw(props: ListBlackListComponentProps, state: ListBlackListComponentState, cssStyle: ListBlackListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getCallerHeaderTitle()}>
                    {this.getContext().getResources().getString(Strings.black_list)}
                </div>
                <p style={cssStyle.getCallerDescriptionDivCSSStyle()}>
                    {this.getContext().getResources().getString(Strings.create_and_manage_list_of_number_to_be_blacklisted)}
                </p>
                <div style={cssStyle.getBlacklistDivCSSStyle()}>
                {  
                  
                  state.listOfBlacklistMembers.length > 0 ?
                  this.getHeader(props,cssStyle):this.getCreateButton(props,cssStyle)

                } 
 
 
                </div>
                
                 <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>
                 <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>



            </div>
        );
    }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    }
    hidePopup()
    { 
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }

    
    onDeleteButtonClick(memberDetailsDto:MemberDetailsDto):void
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true,
             <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={this.getContext().getResources().getString(Strings.are_you_sure_you_want_to_delete_number_from_blacklist)} alertType={AlertType.WARN} onCloseButtonClick={this.hidePopup} onClick={()=>{this.deleteConfirm(memberDetailsDto);}} context={this.getUIProps().context}/>);
    }

    private deleteConfirm(memberDetailsDto:MemberDetailsDto)
    {
        this.hidePopup();
        (this.getUIComponentHandler() as ListBlackListComponentHandler).onDeleteConfirm(memberDetailsDto);
        console.log("onDeleteConfirm1");
    }
    private getHeader(props:ListBlackListComponentProps, cssStyle:ListBlackListCSSStyle):JSX.Element
    {


        return(
            <>
            <div style={cssStyle.getListHeaderWrapperDivCSSStyle()}>
            <div style={cssStyle.getListTitleDivCSSStyle()}>
                  <label style={cssStyle.getListLabelCSSStyle()}>
                       {this.getContext().getResources().getString(Strings.black_list)}
                  </label>
            </div>
            <div style={cssStyle.getButtonDivCSSStyle()}>
               <div style={cssStyle.getCreateButtonDivCSSStyle("55%")}>
                       <ButtonComponent label={props.context.getResources().getString(Strings.add_number)} style={new ButtonCSSStyleImpl(props.context)} onClick={this.onADDNumberClicked} context={props.context}/>
               </div>
           </div>
       </div>
             
            <div style={cssStyle.getBlacklistDiv2CSSStyle()}>
                 {  
                    this.getBlackList(props,this.getUIState() as ListBlackListComponentState)
                 }   
                 </div> 
       </>
        );
    }
    private getCreateButton(props:ListBlackListComponentProps, cssStyle:ListBlackListCSSStyle):JSX.Element
    {
        return(
            <div style={cssStyle.getCreateButtonDivCSSStyle("30%")}>
            <ButtonComponent label={props.context.getResources().getString(Strings.add_number)} style={new ButtonCSSStyleImpl(props.context)} onClick={this.onADDNumberClicked} context={props.context}/>
           </div>
        );
       
    }
    private getBlackList(props:ListBlackListComponentProps,state:ListBlackListComponentState):JSX.Element
    {
        if(state.listOfBlacklistMembers.length > 0)
        {
            this.listViewModel.setListDatas(state.listOfBlacklistMembers);
            return(  <VerticalListComponent listViewModel={this.listViewModel} context={props.context}/>);

        }

        return <span/>;
    }

    private onADDNumberClicked():void
    {                        
        (this.getUIComponentHandler() as ListBlackListComponentHandler).onADDNumberClicked();
    }
  

    // private getBlacklistData():MemberDetailsDto[]
    // {
    //     let data = new MemberDetailsDtoImpl();
    //     data.setMemberName("Name 1");
    //     data.setMsisdn("876543456789");

    //     let data1 = new MemberDetailsDtoImpl();
    //     data1.setMemberName("Name 2");
    //     data.setMsisdn("876543765");
    //     return [data,data1];
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/listblacklistview.tsx